// @flow

import React, { PureComponent } from 'react';
import { makeAsyncSelect } from '@atlaskit/select';
import Toggle from '@atlaskit/toggle';
import { BaseSelect, selectComponents } from '../../components/Select';
import { DialogInner } from '../../components/Popup';

const AsyncSelect = makeAsyncSelect(BaseSelect);

type State = {
    inputValue: string,
    shouldGroupByLabels: boolean,
};

export default class AsyncSelectView extends PureComponent<*, State> {
    state = { inputValue: '', shouldGroupByLabels: this.props.field?.shouldGroupByLabels };

    render() {
        const { storedValue, field, isRemovable, onRemove, loadOptions, toogleGroupByLabels, ...props } = this.props;

        let defaultOptions = props.value;
        if (Array.isArray(field.defaultOptions)) {
            // Show only visible options
            defaultOptions = props.value
                .filter((o) => !field.defaultOptions.includes(o))
                .concat([
                    {
                        label: field.defaultOptionsLabel,
                        options: field.defaultOptions,
                    },
                ]);
        } else if (typeof field.defaultOptions === 'boolean') {
            defaultOptions = field.defaultOptions; // eslint-disable-line prefer-destructuring
        }
        return (
            <DialogInner minWidth={220}>
                <AsyncSelect
                    cacheOptions={field.cacheOptions}
                    components={selectComponents}
                    defaultOptions={defaultOptions}
                    defaultOptionsLabel={field.defaultOptionsLabel}
                    inputValue={field.inputValue}
                    loadOptions={field.loadOptions}
                    onInputChange={field.onInputChange}
                    onMenuScrollToBottom={field.onMenuScrollToBottom}
                    onMenuScrollToTop={field.onMenuScrollToTop}
                    placeholder={field.placeholder}
                    {...props}
                />
                {field?.config?.showToogle ? (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '6px',
                            justifyContent: 'space-between',
                        }}
                    >
                        <span htmlFor="toggle-large">Group by labels</span>
                        <Toggle
                            id="toggle-large"
                            defaultChecked
                            isChecked={this.state.shouldGroupByLabels}
                            onChange={() => {
                                this.setState((prevState) => {
                                    field?.setGroupByLabels(!prevState.shouldGroupByLabels);
                                    return {
                                        shouldGroupByLabels: !prevState.shouldGroupByLabels,
                                    };
                                });
                            }}
                            size="large"
                        />
                    </div>
                ) : null}
            </DialogInner>
        );
    }
}
